import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import { pageAtom, isAuthAtom, customAvatarAtom, myNftBackAtom } from '../../State';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { ReactComponent as BackAddSVG } from '../Images/buttons/backAddButton.svg';
import KUTE from 'kute.js';
import './NFT.css';
import 'react-loading-skeleton/dist/skeleton.css';
import NFTItem from './NFTItem';
import { useTranslation } from 'react-i18next';
import { storage } from '../Util/Firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { ReactComponent as UploadingSVG } from '../Images/buttons/uploadingButton.svg';
import { getImagePath } from '../Util/utils';
import { isMobile } from 'react-device-detect';
import isElectron from '../../Global';
import DataModel from '../Util/DataModel';

export default function NFTBackground({ setNftType }) {
  const callObject = useDaily();
  const localSessionId = useLocalSessionId();

  //Recoil系
  const [myNftBackState, setNftBackState] = useRecoilState(myNftBackAtom);
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);

  const { t } = useTranslation();

  //その他
  const inputFileRef = useRef(null);
  const [uploadingState, setUploadingState] = useState(false);
  const [myCustomBackground, setMyCustomBackground] = useState(null);

  //初期化
  useEffect(() => {
    //データ取得
    getData();
  }, []);

  async function getData() {
    const result = await DataModel.getMyCustomBackground();

    if (result != null) {
      console.log(result);
      if (result.patternID != null) {
        setMyCustomBackground(result.patternID);
      }
    } else {
      setMyCustomBackground(null);
    }
  }

  //写真選択
  const selectPic = async (e) => {
    if (isAuthState == false) {
      alert('You need login');
      return;
    }

    const { files } = e.target;
    let file = files[0];

    //ファイルサイズチェック
    if (file.size > 50000000) {
      alert('File size should be less than 10MB');
      return;
    }

    //タイプチェック
    if (file.type == 'image/png' || file.type == 'image/jpeg' || file.type == 'video/mp4') {
    } else {
      alert('Only Jpeg, PNG and mp4 format are accepted');
      return;
    }

    //ステータス変更
    setUploadingState(true);

    //UUID取得
    let uuid;
    try {
      let uuidResult = await DataModel.getUUID();
      if (uuidResult != null) {
        uuid = uuidResult.uuid;
      }
    } catch (e) {
      console.log(e);
    }

    //名前の変更
    let name = 'custom' + uuid + '.' + file.name.split('.').pop();

    const storageRef = ref(storage, `/mybackground/${name}`);

    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const percent = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100); // update progress
        console.log(percent);
      },
      (err) => setUploadingState(false),
      async () => {
        //        setNftBackState(name);

        //データベースに保存
        let result = await DataModel.saveCustomBackground(name);

        if (result != null) {
          setMyCustomBackground(name);
        }

        //ステータス変更
        setUploadingState(false);

        //ミーティングセッションに保存
        //saveData(name);
        // //URLを取得
        // getDownloadURL(uploadTask.snapshot.ref).then(async (url) => {
        //   console.log('アップロード完了');
        //   console.log(url);
        // });
      },
    );
  };

  //データベースに保存
  function saveGreen() {
    let imageURL = 'greenBack.png';

    //全体に設定
    setNftBackState(imageURL);

    //ローカルストレージに保存
    localStorage.setItem('backImageURL', imageURL);

    //データベースに保存(usersに保存)
    if (isAuthState) {
      DataModel.saveUserData('backImage', imageURL);
    }

    //セッション内入っている場合は、セッションデータベースも更新
    if (callObject != null) {
      callObject
        .getMeetingSession()
        .then(async (session) => {
          //自分の情報をseessionに登録
          DataModel.updateSessionToRoom(session.meetingSession.id, 'backImage', imageURL);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  //データベースに保存
  //if (callObject != null) {
  // callObject
  //   .getMeetingSession()
  //   .then(async (session) => {
  //     try {
  //       //自分の情報をseessionに登録
  //       await DataModel.saveSessionToRoom(
  //         null, //ルームID
  //         session.meetingSession.id, //ルームのセッションID
  //         localSessionId, //ユーザーのテンポラリーユーザーID
  //         null, //顔
  //         'greenBack.png', //背景
  //         null, //顔認識 <isFaceTrackingå>
  //         null, //録画中
  //         null, //ミュート
  //         null, //WhoUse
  //         null, //ユーザー他タイプ
  //         null,
  //       );

  //       console.log('セッション保存完了');
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   })
  //   .catch((error) => {
  //     console.log(error);
  //   });
  //}
  // }

  //背景リストの表
  return (
    <>
      {/* <div className="renew">
        <div className="myNFTAvatarWrapWrap">
          <div className="myNFTAvatarWrap selected" onClick={() => setNftType('background')}>
            {t('nft.Image')}
          </div>
          <div className="myNFTAvatarWrap" onClick={() => setNftType('BGM')}>
            {t('nft.Music')}
          </div>
        </div>
      </div> */}

      {/*背景一覧 */}
      <div className="nftListTitle4">{t('nft.My background')}</div>
      <div className="nftListBody">
        {t('nft.Use your image (JPEG or PNG) video (MP4) for background')}
      </div>
      <div className="renew">
        <div className="nftBackgroundList">
          {uploadingState == false ? (
            <div className="nftItem addButton">
              <BackAddSVG onClick={() => inputFileRef.current?.click()} />
              <input
                ref={inputFileRef}
                type="file"
                accept="image/png, image/jpeg, video/mp4"
                style={{ display: 'none' }}
                onChange={selectPic}
              />
            </div>
          ) : (
            <div className="myBackgroundWrap">
              <div id="myBackgroundWrapInside">
                <UploadingSVG />
              </div>
              <div className="myBackgroundText">{t('nft.Uploading...')}</div>
            </div>
          )}
          {myCustomBackground != null && <NFTItem imageURL={myCustomBackground} type={'back'} />}
        </div>
      </div>

      <div className="nftListTitle4">{t('nft.Solid Color')}</div>
      <div className="renew">
        <div className="nftBackgroundList">
          <NFTItem imageURL={'whiteYellow.png'} type={'back'} />
          <NFTItem imageURL={'c1.png'} type={'back'} />
          <NFTItem imageURL={'c2.png'} type={'back'} />
          <NFTItem imageURL={'c3.png'} type={'back'} />
          <NFTItem imageURL={'black1.png'} type={'back'} />
          {/* <NFTItem imageURL={'greenBack.png'} type={'back'} /> */}
        </div>
        <div className="nftBackgroundGreen" onClick={saveGreen}>
          <img src={getImagePath() + '/background/greenBack.png'} />
          <div>{t('nft.Use green for video editing')}</div>
        </div>
      </div>
      {/* <div className="nftListTitle4">{t('nft.Graphic Art')}</div>
      <div className="renew">
        <div className="nftBackgroundList">
        
        </div>
      </div> */}
    </>
  );
}
